import { sendGoogleGoal } from 'www/utils'

sendGoogleGoal('visit_lpu_page')
